"use client";

import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import Image from "../../../components/AppImage";

const TeamSection = () => {
  const teamMembers = [
    { id: 1, name: "Prashanth", specialization: "Chief Executing Officer", avatar: "/assets/images/prashanth.jpg" },
    { id: 2, name: "Nishok", specialization: "Chief Marketing Officer", avatar: "/assets/images/nishok.jpg" },
    { id: 3, name: "Jerome Joshua", specialization: "Chief Operating Officer", avatar: "/assets/images/jerome.jpg" },
    //{ id: 4, name: "Vijay Dharmaraj", specialization: "Senior Cybersecurity Specialist", avatar: "/assets/images/default-avatar.png" },
    //{ id: 5, name: "Vinod Daniel Dharmaraj", specialization: "Senior AI & ML Specialist", avatar: "/assets/images/vinod.png" },
    { id: 6, name: "Adan Kriston", specialization: "R&D Manager", avatar: "/assets/images/adan.jpg" },
    { id: 7, name: "Krishnan", specialization: "Designing Manager", avatar: "/assets/images/krishnan.jpg" },
    { id: 8, name: "Vignesh", specialization: "Project Manager", avatar: "/assets/images/wikki.jpg" },
    { id: 9, name: "Shyam Kumar", specialization: "Training Manager", avatar: "/assets/images/shyam.jpg" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    mode: "free-snap",
    slides: { perView: 3, spacing: 24 },
    breakpoints: {
      "(max-width: 1024px)": { slides: { perView: 2, spacing: 20 } },
      "(max-width: 640px)": { slides: { perView: 1, spacing: 12 } },
    },
    created: (s) => setCurrentSlide(s.track.details.rel),
    slideChanged: (s) => setCurrentSlide(s.track.details.rel),
  });

  return (
    <section id="mentors" className="py-16 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
          <span className="text-nipix-blue">O</span>
          <span className="text-black">ur </span>
          <span className="text-nipix-blue">T</span>
          <span className="text-black">eam </span>
        </h2>

        <div className="relative">
          {/* Carousel */}
          <div ref={sliderRef} className="keen-slider">
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="keen-slider__slide flex flex-col items-center justify-center"
              >
                <div className="rounded-2xl overflow-hidden border border-gray-800 bg-white w-60 h-80 shadow-md">
                  <Image
                    src={member.avatar}
                    alt={member.name}
                    className="w-full h-full object-cover block"
                  />
                </div>
                <h3 className="mt-4 text-lg font-bold text-nipix-blue">
                  {member.name}
                </h3>
                <p className="text-sm text-black">{member.specialization}</p>
              </div>
            ))}
          </div>

          {/* Arrows */}
          <button
            onClick={() => instanceRef.current?.prev()}
            aria-label="Previous"
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700"
            style={{ zIndex: 50 }}
          >
            ◀
          </button>
          <button
            onClick={() => instanceRef.current?.next()}
            aria-label="Next"
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700"
            style={{ zIndex: 50 }}
          >
            ▶
          </button>
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center mt-6 space-x-3">
          {teamMembers.map((_, idx) => (
            <button
              key={idx}
              onClick={() => instanceRef.current?.moveToIdx(idx)}
              aria-label={`Go to slide ${idx + 1}`}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                idx === currentSlide ? "bg-blue-600 scale-110" : "bg-gray-600"
              }`}
              style={{ outline: "none" }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
